'use strict';
import * as $j_app$002eauth$002e$002dClient$002dSide$002dAuth$002dUser from "./app.auth.-Client-Side-Auth-User.js";
import * as $j_app$002epages$002e$002dApp$002dPage$0024$002dRoot$0024 from "./app.pages.-App-Page$-Root$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_auth_package$() {
  this.Lapp_auth_package$__f_RootPage$lzy1 = null;
  this.Lapp_auth_package$__f_RootPagebitmap$1 = false;
  this.Lapp_auth_package$__f_ClientAuthState$lzy1 = null;
  this.Lapp_auth_package$__f_ClientAuthStatebitmap$1 = false;
  this.Lapp_auth_package$__f_rootPage$lzy1 = null;
  this.Lapp_auth_package$__f_rootPagebitmap$1 = false;
}
export { $c_Lapp_auth_package$ as $c_Lapp_auth_package$ };
$c_Lapp_auth_package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_auth_package$.prototype.constructor = $c_Lapp_auth_package$;
/** @constructor */
function $h_Lapp_auth_package$() {
}
export { $h_Lapp_auth_package$ as $h_Lapp_auth_package$ };
$h_Lapp_auth_package$.prototype = $c_Lapp_auth_package$.prototype;
$c_Lapp_auth_package$.prototype.RootPage__Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage$ = (function() {
  if ((!this.Lapp_auth_package$__f_RootPagebitmap$1)) {
    this.Lapp_auth_package$__f_RootPage$lzy1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage$(this);
    this.Lapp_auth_package$__f_RootPagebitmap$1 = true;
  }
  return this.Lapp_auth_package$__f_RootPage$lzy1;
});
$c_Lapp_auth_package$.prototype.ClientAuthState__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$ = (function() {
  if ((!this.Lapp_auth_package$__f_ClientAuthStatebitmap$1)) {
    this.Lapp_auth_package$__f_ClientAuthState$lzy1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$(this);
    this.Lapp_auth_package$__f_ClientAuthStatebitmap$1 = true;
  }
  return this.Lapp_auth_package$__f_ClientAuthState$lzy1;
});
$c_Lapp_auth_package$.prototype.rootPage__Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage = (function() {
  if ((!this.Lapp_auth_package$__f_rootPagebitmap$1)) {
    this.Lapp_auth_package$__f_rootPage$lzy1 = $m_Lapp_auth_package$().RootPage__Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage$().apply__O__Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage($j_app$002epages$002e$002dApp$002dPage$0024$002dRoot$0024.$m_Lapp_pages_AppPage$Root$());
    this.Lapp_auth_package$__f_rootPagebitmap$1 = true;
  }
  return this.Lapp_auth_package$__f_rootPage$lzy1;
});
$c_Lapp_auth_package$.prototype.displayName__Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__Lframework_data_LocalLoadingStatus = (function(state) {
  var this$1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__asAuthenticated__s_Option(state);
  if (this$1.isEmpty__Z()) {
    var this$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = this$1.get__O();
    var value = x0.Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$Authenticated__f_serverData.displayName__T();
    var value$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
    var this$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_LocalLoadingStatus$Loaded(value$1));
  }
  if (this$4.isEmpty__Z()) {
    matchResult1: {
      var $x_2;
      var x1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__asClientSideHasRespondedState__s_Option(state);
      var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      if ((x === x1)) {
        var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_data_LocalLoadingStatus$Loading$();
        break matchResult1;
      }
      if ((x1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
        var state$1 = x1.s_Some__f_value;
        var this$5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthClientSideHasRespondedState__maybeClientData__s_Option(state$1);
        if (this$5.isEmpty__Z()) {
          var value$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        } else {
          var x0$1 = this$5.get__O();
          var value$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($j_app$002eauth$002e$002dClient$002dSide$002dAuth$002dUser.$f_Lapp_auth_ClientSideAuthUser__displayName__T(x0$1));
        }
        var $x_2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_LocalLoadingStatus$Loaded(value$2);
        break matchResult1;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
    }
    var $x_1 = $x_2;
  } else {
    var $x_1 = this$4.get__O();
  }
  return $x_1;
});
var $d_Lapp_auth_package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_auth_package$, "app.auth.package$", ({
  Lapp_auth_package$: 1,
  Lframework_data_AuthPlatformForClientAndServerSideAuth: 1
}));
export { $d_Lapp_auth_package$ as $d_Lapp_auth_package$ };
var $n_Lapp_auth_package$;
function $m_Lapp_auth_package$() {
  if ((!$n_Lapp_auth_package$)) {
    $n_Lapp_auth_package$ = new $c_Lapp_auth_package$();
  }
  return $n_Lapp_auth_package$;
}
export { $m_Lapp_auth_package$ as $m_Lapp_auth_package$ };
//# sourceMappingURL=app.auth.package$.js.map
